export default [
  {
    value: 'chat',
    label: ' Chat',
  },
  {
    value: 'video',
    label: 'Video',
  },

];
